import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderTopSection from "../../components/partials/HeaderTop";
import Footer from "../../components/partials/Footer";
import LoadingSpinner from "../../utils/LoadingSpinner";

const SoutienScolaire = () => {
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        // Simuler le chargement des ressources
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    // Vérifier si l'utilisateur est connecté
    const isUserLoggedIn = () => {
        // Vérifier la présence d'un token ou d'infos utilisateur dans le localStorage/sessionStorage
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        const user = localStorage.getItem('user') || sessionStorage.getItem('user');
        return !!(token || user);
    };

    // Gérer la redirection après clic sur un bouton
    const handleProfessionalRedirect = () => {
        if (isUserLoggedIn()) {
            navigate('/professional-candidate');
        } else {
            navigate('/professionals');
        }
    };

    return (
        <>
            {/* Affichage du spinner de chargement */}
            <LoadingSpinner
                isVisible={isLoading}
                loadingText="Chargement de la page..."
            />

            <HeaderTopSection/>

            <main className="main overflow-hidden">

                {/* Hero Section */}
                <section className="hero-section bg-gradient-primary py-xxl-25 py-20 position-relative overflow-hidden">
                    <div className="container position-relative z-1">
                        <div className="row align-items-center justify-content-lg-between justify-content-center">
                            <div className="col-xxl-6 col-xl-5 col-lg-5 col-md-8">
                                <div className="hero-content text-lg-start text-center">
                                    <div className="section-title">
                                        <div className="badge-section mb-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="800">
                                            <span className="badge bg-white text-primary fw-700 fs-15 px-4 py-2 rounded-pill shadow-sm">
                                                📚 SOUTIEN SCOLAIRE
                                            </span>
                                        </div>
                                        <h1 className="text-white fw-800 mb-xxl-6 mb-xl-5 mb-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000">
                                            Apprentissage sur mesure<br/>
                                            <span className="text-warning">pour enfants, jeunes et adultes</span>
                                        </h1>
                                        <p className="text-light fs-20 mb-5 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                                            Des professeurs qualifiés pour accompagner la réussite scolaire de vos enfants
                                        </p>
                                        <div className="hero-features aos-init aos-animate" data-aos="fade-up" data-aos-duration="1400">
                                            <div className="d-flex flex-wrap gap-3 justify-content-lg-start justify-content-center">
                                                <div className="feature-tag bg-white bg-opacity-25 text-white px-4 py-2 rounded-pill fs-15 fw-600">
                                                    🎓 Professeurs diplômés
                                                </div>
                                                <div className="feature-tag bg-white bg-opacity-25 text-white px-4 py-2 rounded-pill fs-15 fw-600">
                                                    💻 Cours en présentiel ou webcam
                                                </div>
                                                <div className="feature-tag bg-white bg-opacity-25 text-white px-4 py-2 rounded-pill fs-15 fw-600">
                                                    📈 Progrès garantis
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-5 col-lg-5">
                                <div className="hero-image position-relative aos-init aos-animate"
                                     data-aos="zoom-in" data-aos-duration="1500">
                                    <div className="floating-elements">
                                        <div className="floating-card card1 bg-white shadow-lg rounded-4 p-4 position-absolute">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon-circle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center">
                                                    ⭐
                                                </div>
                                                <div>
                                                    <h6 className="fw-700 mb-1">4.8/5</h6>
                                                    <small className="text-muted fs-14">Satisfaction parents</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="floating-card card2 bg-white shadow-lg rounded-4 p-4 position-absolute">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon-circle bg-success text-white rounded-circle d-flex align-items-center justify-content-center">
                                                    👥
                                                </div>
                                                <div>
                                                    <h6 className="fw-700 mb-1">1000+</h6>
                                                    <small className="text-muted fs-14">Professeurs disponibles</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <img src="assets/images/service/soutien-scolaire/hero-soutien.jpg"
                                         alt="Cours de soutien scolaire"
                                         className="img-fluid rounded-4 shadow-lg"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wave-bg"></div>
                </section>

                {/* Section Processus */}
                <section className="process-section py-xxl-25 py-20 bg-light">
                    <div className="container">
                        <div className="row justify-content-center mb-xxl-15 mb-xl-10 mb-8">
                            <div className="col-lg-8 text-center">
                                <div className="">
                                    <h2 className="fw-800 text-dark mb-4 fs-32">
                                        Trouvez votre professeur en 3 étapes
                                    </h2>
                                </div>
                                <p className="text-muted fs-20">
                                    Un accompagnement personnalisé pour la réussite scolaire
                                </p>
                            </div>
                        </div>
                        <div className="row g-4 justify-content-center">
                            <div className="col-lg-4 col-md-6">
                                <div className="process-card card border-0 shadow-sm h-100 text-center p-5 rounded-4 aos-init aos-animate"
                                     data-aos="fade-up" data-aos-duration="800">
                                    <div className="process-number bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto fw-800">
                                        1
                                    </div>
                                    <h5 className="fw-700 mb-3 fs-18">Choisissez la matière</h5>
                                    <p className="text-muted fs-16">
                                        Sélectionnez la discipline et le niveau scolaire de votre enfant
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="process-card card border-0 shadow-sm h-100 text-center p-5 rounded-4 aos-init aos-animate"
                                     data-aos="fade-up" data-aos-duration="1000">
                                    <div className="process-number bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto fw-800">
                                        2
                                    </div>
                                    <h5 className="fw-700 mb-3 fs-18">Consultez les profils</h5>
                                    <p className="text-muted fs-16">
                                        Découvrez les professeurs disponibles avec leurs qualifications et avis
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="process-card card border-0 shadow-sm h-100 text-center p-5 rounded-4 aos-init aos-animate"
                                     data-aos="fade-up" data-aos-duration="1200">
                                    <div className="process-number bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto fw-800">
                                        3
                                    </div>
                                    <h5 className="fw-700 mb-3 fs-18">Démarrez les cours</h5>
                                    <p className="text-muted fs-16">
                                        Planifiez les séances à domicile ou en ligne selon vos disponibilités
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-6">
                            <div className="col-lg-8 text-center">
                                <div className="bg-white rounded-4 p-4 shadow-sm">
                                    <p className="text-primary fw-600 fs-16 mb-0">
                                        💡 <strong>Flexibilité totale :</strong> Cours à domicile ou par webcam, selon vos préférences
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Section Services */}
                <section className="services-section py-xxl-25 py-20">
                    <div className="container">
                        <div className="row justify-content-center mb-xxl-15 mb-xl-10 mb-8">
                            <div className="col-lg-8 text-center">
                                <div className="">
                                    <h2 className="fw-800 text-dark mb-4 fs-32">
                                        Nos solutions d'accompagnement
                                    </h2>
                                    <p className="text-muted fs-20">
                                        Un soutien adapté à chaque besoin éducatif
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Service 1 - Professeurs diplômés */}
                        <section className="service-card card border-0 shadow-lg mb-6 rounded-4 overflow-hidden">
                            <div className="container p-12">
                                <div className="row g-6 align-items-md-center justify-content-between">
                                    <div className="col-lg-5 col-md-6 col-sm-6">
                                        <div className="quick-thumb w-100 overflow-hidden aos-init aos-animate"
                                             data-aos="zoom-in-right" data-aos-duration="1500"
                                             style={{borderRadius: '10%'}}>
                                            <img
                                                src="assets/images/service/soutien-scolaire/professeurs-diplomes.jpg"
                                                alt="Professeurs diplômés" className="w-100"/>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="quick-content">
                                            <div className="service-icon bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4">
                                                🎓
                                            </div>
                                            <h3 className="fw-800 text-dark mb-4 fs-28">Professeurs diplômés</h3>

                                            <p className="text-muted fs-16 mb-4">
                                                Avec un large choix de professeurs diplômés de métier, trouvez la personne idéale
                                                pour aider vos enfants à se perfectionner dans plus de 20 matières du niveau primaire au lycée.
                                            </p>

                                            <div className="mb-4">
                                                <h6 className="fw-700 text-dark mb-3 fs-17">Nos atouts :</h6>
                                                <ul className="text-muted fs-16">
                                                    <li className="mb-2">• <strong>Expertise pédagogique</strong> - diplômes et expérience vérifiés</li>
                                                    <li className="mb-2">• <strong>Méthodologie adaptée</strong> - approche personnalisée pour chaque élève</li>
                                                    <li className="mb-2">• <strong>Suivi régulier</strong> - évaluation continue des progrès</li>
                                                </ul>
                                            </div>

                                            <p className="text-muted fs-16 mb-4">
                                                Que ce soit pour combler des lacunes ou pour se perfectionner, nos professeurs
                                                accompagnent vos enfants vers l'excellence scolaire.
                                            </p>

                                            <ul className="service-features list-unstyled mb-4">
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Qualifications vérifiées</span>
                                                </li>
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Expérience pédagogique</span>
                                                </li>
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Programme personnalisé</span>
                                                </li>
                                            </ul>

                                            <button
                                                onClick={handleProfessionalRedirect}
                                                className="btn btn-primary fw-600 px-5 py-3 rounded-pill fs-16">
                                                Voir les professeurs
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Service 2 - Aide aux devoirs */}
                        <div className="service-card card border-0 shadow-lg mb-6 rounded-4 overflow-hidden">
                            <div className="row g-0 align-items-center flex-lg-row-reverse">
                                <div className="col-lg-6 pb-12">
                                    <div className="p-xxl-8 p-xl-6 p-5">
                                        <div className="service-icon bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4">
                                            📝
                                        </div>
                                        <h3 className="fw-800 text-dark mb-4 fs-28">Aide aux devoirs</h3>

                                        <p className="text-muted fs-16 mb-4">
                                            De nombreux étudiant.e.s sont disponibles pour l'aide aux devoirs, à domicile ou par webcam.
                                            Une solution idéale pour maintenir un enseignement stable et lutter contre le décrochage scolaire.
                                        </p>

                                        <div className="mb-4">
                                            <h6 className="fw-700 text-dark mb-3 fs-17">Bénéfices :</h6>
                                            <ul className="text-muted fs-16">
                                                <li className="mb-2">• <strong>Proximité générationnelle</strong> - meilleure compréhension des difficultés</li>
                                                <li className="mb-2">• <strong>Flexibilité horaire</strong> - adaptation aux emplois du temps chargés</li>
                                                <li className="mb-2">• <strong>Tarifs accessibles</strong> - solution économique pour un suivi régulier</li>
                                            </ul>
                                        </div>

                                        <p className="text-muted fs-16 mb-4">
                                            En période de crise sanitaire ou tout au long de l'année, l'aide aux devoirs
                                            permet d'assurer la continuité pédagogique et le succès académique.
                                        </p>

                                        <ul className="service-features list-unstyled mb-4">
                                            <li className="d-flex align-items-center gap-3 mb-3">
                                                <span className="text-success fs-18">✓</span>
                                                <span className="fs-16">Étudiants sélectionnés</span>
                                            </li>
                                            <li className="d-flex align-items-center gap-3 mb-3">
                                                <span className="text-success fs-18">✓</span>
                                                <span className="fs-16">Disponibilité étendue</span>
                                            </li>
                                            <li className="d-flex align-items-center gap-3 mb-3">
                                                <span className="text-success fs-18">✓</span>
                                                <span className="fs-16">Suivi personnalisé</span>
                                            </li>
                                        </ul>
                                        <button
                                            onClick={handleProfessionalRedirect}
                                            className="btn btn-warning text-white fw-600 px-5 py-3 rounded-pill fs-16">
                                            Trouver un tuteur
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <img
                                        src="assets/images/service/soutien-scolaire/aide-devoirs.jpg"
                                        alt="Aide aux devoirs"
                                        className="img-fluid h-100 object-fit-cover"/>
                                </div>
                            </div>
                        </div>

                        {/* Service 3 - Cours disponibles */}
                        <section className="service-card card border-0 shadow-lg rounded-4 overflow-hidden">
                            <div className="container">
                                <div className="row g-6 align-items-md-center justify-content-between">
                                    <div className="col-lg-6 col-md-6 col-sm-6 p-12">
                                        <div className="quick-content">
                                            <div className="service-icon bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4">
                                                📚
                                            </div>
                                            <h3 className="fw-800 text-dark mb-4 fs-28">Cours de soutien disponibles</h3>

                                            <p className="text-muted fs-16 mb-4">
                                                Plus de 20 matières sont disponibles sur notre plateforme, dispensées du niveau primaire au niveau lycée.
                                            </p>

                                            <div className="row mb-4">
                                                <div className="col-md-6">
                                                    <div className="subject-category mb-4">
                                                        <h6 className="fw-700 text-dark mb-3 fs-17">AIDE AUX DEVOIRS</h6>
                                                        <ul className="text-muted fs-16">
                                                            <li className="mb-2">• Anglais</li>
                                                            <li className="mb-2">• Français</li>
                                                            <li className="mb-2">• Mathématiques</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="subject-category mb-4">
                                                        <h6 className="fw-700 text-dark mb-3 fs-17">LANGUES</h6>
                                                        <ul className="text-muted fs-16">
                                                            <li className="mb-2">• Arabe</li>
                                                            <li className="mb-2">• Espagnol</li>
                                                            <li className="mb-2">• Italien</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mb-4">
                                                <h6 className="fw-700 text-dark mb-3 fs-17">Autres matières disponibles :</h6>
                                                <p className="text-muted fs-16">
                                                    Physique, Chimie, SVT, Histoire-Géographie, Philosophie, Économie,
                                                    et bien d'autres disciplines selon vos besoins.
                                                </p>
                                            </div>

                                            <p className="text-muted fs-16 mb-4">
                                                Quel que soit le niveau ou la matière, nous trouvons le professeur
                                                idéal pour accompagner votre enfant vers la réussite.
                                            </p>

                                            <button
                                                onClick={handleProfessionalRedirect}
                                                className="btn btn-success fw-600 px-5 py-3 rounded-pill fs-16">
                                                Découvrir tous les cours
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-6 col-sm-6">
                                        <div className="quick-thumb w-100 overflow-hidden aos-init aos-animate"
                                             data-aos="zoom-in-right" data-aos-duration="1500"
                                             style={{borderRadius: '10%'}}>
                                            <img src="assets/images/service/soutien-scolaire/cours-disponibles.jpg"
                                                 alt="Cours de soutien disponibles"
                                                 className="w-100"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>

                {/* Section CTA */}
                <section className="cta-section bg-primary py-xxl-25 py-20">
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h2 className="text-white fw-800 mb-4 fs-32">
                                    Donnez les clés de la réussite à vos enfants
                                </h2>
                                <p className="text-light mb-5 fs-20">
                                    Rejoignez les milliers de familles qui nous font confiance pour l'éducation de leurs enfants
                                </p>
                                <div className="d-flex flex-wrap gap-4 justify-content-center">
                                    <button
                                        onClick={handleProfessionalRedirect}
                                        className="btn btn-success fw-600 px-5 py-3 rounded-pill fs-16">
                                        Trouver un professeur
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>

            <Footer/>

            <style jsx>{`
                .bg-gradient-primary {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                }

                .wave-bg {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 100px;
                    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z' fill='white'%3E%3C/path%3E%3C/svg%3E");
                    background-size: cover;
                    background-position: center;
                }

                .hero-image {
                    position: relative;
                }

                .floating-card {
                    z-index: 2;
                }

                .card1 {
                    top: 20px;
                    left: -20px;
                    animation: float 3s ease-in-out infinite;
                }

                .card2 {
                    bottom: 20px;
                    right: -20px;
                    animation: float 3s ease-in-out infinite 1.5s;
                }

                .icon-circle {
                    width: 40px;
                    height: 40px;
                    font-size: 18px;
                }

                .process-number {
                    width: 60px;
                    height: 60px;
                    font-size: 24px;
                    font-weight: bold;
                }

                .service-icon {
                    width: 80px;
                    height: 80px;
                    font-size: 32px;
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }

                .service-card img {
                    transition: transform 0.3s ease;
                }

                .service-card:hover img {
                    transform: scale(1.05);
                }

                .btn {
                    transition: all 0.3s ease;
                }

                .btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
                }

                /* Améliorations typographiques */
                .fs-14 { font-size: 14px; }
                .fs-15 { font-size: 15px; }
                .fs-16 { font-size: 16px; }
                .fs-17 { font-size: 17px; }
                .fs-18 { font-size: 18px; }
                .fs-20 { font-size: 20px; }
                .fs-28 { font-size: 28px; }
                .fs-32 { font-size: 32px; }

                .fw-600 { font-weight: 600; }
                .fw-700 { font-weight: 700; }
                .fw-800 { font-weight: 800; }

                .subject-category {
                    background: #f8f9fa;
                    padding: 20px;
                    border-radius: 12px;
                    border-left: 4px solid #28a745;
                }
            `}</style>
        </>
    );
};

export default SoutienScolaire;